/*
  CUSTOM (A/B test, PR.9): the delivery row in the product page info box (snippets/pdp-infofelt.liquid).

  "Bestil inden 03:12:00" counts down to the order deadline of the next shipping day, and the line under it gives
  the delivery date: the shipping day plus the transit days, on delivery days only, skipping closed dates.
  All times are the shop's (data-time-zone), not the visitor's.
  - A shipping day is Monday to Friday (and Saturday when data-ship-saturday is true) that is not a closed date.
  - A delivery day is Monday to Friday (and Saturday when data-deliver-saturday is true) that is not a closed date.
  - Past the deadline, or on a day without shipping, the next shipping day counts. More than 24 hours away, the
    countdown is replaced by the day ("mandag kl. 19"), so it never shows a 50-hour timer.
  A preorder size shows its expected delivery instead; the size is followed through variant:change (assets/theme.js).
*/
(function () {
  var $row = document.querySelector('[data-pdp-delivery]');
  if (!$row) return;

  var $stock = $row.querySelector('[data-pdp-delivery-stock]');
  var $preorder = $row.querySelector('[data-pdp-delivery-preorder]');
  var $countdown = $row.querySelector('[data-pdp-countdown]');
  var $date = $row.querySelector('[data-pdp-delivery-date]');
  var $preorderLine = $row.querySelector('[data-pdp-preorder-line]');

  var deadlineHour = parseInt($row.dataset.deadlineHour, 10) || 19;
  var shipSaturday = $row.dataset.shipSaturday === 'true';
  var deliverSaturday = $row.dataset.deliverSaturday === 'true';
  var transitDays = Math.max(0, parseInt($row.dataset.transitDays, 10) || 0);
  var timeZone = $row.dataset.timeZone || 'Europe/Copenhagen';
  var lineTemplate = $row.dataset.line || '';
  // "og få den allerede <strong>i morgen</strong>" instead of the date when the delivery is tomorrow (the editor's rich text)
  var tomorrowLine = $row.dataset.lineTomorrow || '';
  var laterTemplate = $row.dataset.later || '';
  var preorderTemplate = $row.dataset.preorderLine || '';
  var closed = ($row.dataset.closed || '').match(/\d{4}-\d{2}-\d{2}/g) || [];
  var lang = document.documentElement.lang || 'da';

  var preorders = {};
  try {
    preorders = JSON.parse($row.querySelector('[data-pdp-preorders]').textContent);
  } catch (e) { /* no map: the row stays as rendered */ }

  // The shop's own date and time right now, from the time zone, as numbers
  var partsFormat = new Intl.DateTimeFormat('en-GB', {
    timeZone: timeZone, year: 'numeric', month: '2-digit', day: '2-digit',
    hour: '2-digit', minute: '2-digit', second: '2-digit', hourCycle: 'h23'
  });

  function shopNow() {
    var parts = {};
    partsFormat.formatToParts(new Date()).forEach(function (part) { parts[part.type] = part.value; });
    return {
      day: Date.UTC(+parts.year, +parts.month - 1, +parts.day), // the shop's calendar day, as a UTC midnight
      seconds: (+parts.hour) * 3600 + (+parts.minute) * 60 + (+parts.second)
    };
  }

  var DAY = 86400000;

  function isoDate(day) {
    return new Date(day).toISOString().slice(0, 10);
  }

  function isShipDay(day) {
    var weekday = new Date(day).getUTCDay();
    if (weekday === 0 || (weekday === 6 && !shipSaturday)) return false;
    return closed.indexOf(isoDate(day)) === -1;
  }

  function isDeliveryDay(day) {
    var weekday = new Date(day).getUTCDay();
    if (weekday === 0 || (weekday === 6 && !deliverSaturday)) return false;
    return closed.indexOf(isoDate(day)) === -1;
  }

  // the next shipping day (today while before the deadline) and the delivery day that follows from it
  function plan(now) {
    var ship = now.day;
    if (!isShipDay(ship) || now.seconds >= deadlineHour * 3600) {
      do { ship += DAY; } while (!isShipDay(ship));
    }

    var delivery = ship;
    for (var i = 0; i < transitDays; i++) {
      do { delivery += DAY; } while (!isDeliveryDay(delivery));
    }

    var secondsLeft = (ship - now.day) / 1000 + deadlineHour * 3600 - now.seconds;
    return { ship: ship, delivery: delivery, secondsLeft: secondsLeft };
  }

  function pad(n) {
    return (n < 10 ? '0' : '') + n;
  }

  function dayName(day) {
    return new Intl.DateTimeFormat(lang, { weekday: 'long', timeZone: 'UTC' }).format(new Date(day));
  }

  function monthName(day) {
    return new Intl.DateTimeFormat(lang, { month: 'long', timeZone: 'UTC' }).format(new Date(day));
  }

  var lastDelivery = null;

  function render() {
    var now = shopNow();
    var p = plan(now);

    if (p.secondsLeft <= 24 * 3600) {
      var s = Math.max(0, Math.floor(p.secondsLeft));
      $countdown.textContent = pad(Math.floor(s / 3600)) + ':' + pad(Math.floor(s % 3600 / 60)) + ':' + pad(s % 60);
    } else if (laterTemplate) {
      $countdown.textContent = laterTemplate.replace('[weekday]', dayName(p.ship)).replace('[hour]', deadlineHour);
    }

    // the shop's tomorrow counts, so the line also turns to "i morgen" at the shop's midnight
    var tomorrow = tomorrowLine !== '' && p.delivery === now.day + DAY;
    var delivery = p.delivery + (tomorrow ? ':tomorrow' : '');
    if (delivery !== lastDelivery) {
      lastDelivery = delivery;
      if (tomorrow) {
        $date.innerHTML = tomorrowLine;
      } else {
        $date.textContent = lineTemplate
          .replace('[weekday]', dayName(p.delivery))
          .replace('[day]', new Date(p.delivery).getUTCDate())
          .replace('[month]', monthName(p.delivery));
      }
    }
  }

  render();
  setInterval(render, 1000);

  // a preorder size shows its expected delivery instead of the countdown
  function showVariant(id) {
    if (!(String(id) in preorders)) return;
    var eta = preorders[id];
    $stock.hidden = eta !== false;
    $preorder.hidden = eta === false;
    if (eta !== false && $preorderLine) {
      $preorderLine.textContent = eta && preorderTemplate ? preorderTemplate.replace('[month]', eta) : '';
    }
  }

  document.addEventListener('variant:change', function (e) {
    if (e.detail && e.detail.variant) showVariant(e.detail.variant.id);
  });
})();
